import SqlTemplatesService from "@app/services/http/sql-templates.service";
import {
  SqlTemplate,
  UpdateSqlTemplateRequest,
} from "@app/types/sql-templates.type";
import toast from "react-hot-toast";
import { openPortalDialog } from "@app/services/modal.service";
import SqlTemplateModal from "@app/components/sql-template-model/sql-template-model.component";
import EditIcon from "@app/icons/edit";
import DeleteIcon from "@app/icons/delete";

interface PredefinedQueryProps {
  setValue: (value: string) => void;
  templates: SqlTemplate[];
  fetchTemplates: () => Promise<void>;
}

function PredefinedQuery({
  setValue,
  templates,
  fetchTemplates,
}: PredefinedQueryProps) {
  const handleEditClick = (sqlTemplate: SqlTemplate) => {
    const sqlTemplateModalObs = openPortalDialog(SqlTemplateModal, {
      sqlTemplate,
    });

    sqlTemplateModalObs.afterClosed().subscribe((data) => {
      if (data?.sqlTemplate) {
        const updateSqlTemplate: UpdateSqlTemplateRequest = {
          sqlTemplate: data.sqlTemplate.sqlTemplate,
          name: data.sqlTemplate.name,
        };

        SqlTemplatesService.update(sqlTemplate.id, updateSqlTemplate).then(
          () => {
            toast.success("Template updated successfully");
            fetchTemplates();
          }
        );
      }
    });
  };

  const handleDelete = async (templateId: number) => {
    try {
      await SqlTemplatesService.delete(templateId);
      await fetchTemplates();
      toast.success("Template deleted successfully");
    } catch (error: any) {
      toast.error(error.message || "Failed to delete SQL template");
    }
  };

  return (
    <div className="px-4">
      <div className="font-semibold mb-4">Saved SQL Templates</div>
      <div className="space-y-2">
        {templates.map((template) => (
          <div
            key={template.id}
            className="relative group bg-gray-100 hover:bg-gray-200 p-4 rounded-lg cursor-pointer transition-all"
            onClick={() => {
              setValue(template.sqlStatement);
            }}
          >
            <div>
              <p className="font-semibold mb-1">{template.name}</p>
              <p className="text-xs truncate font-mono bg-gray-800 text-white p-2 rounded">
                {template.sqlStatement}
              </p>
            </div>
            <div className="absolute top-2 right-2 flex">
              <button
                className="mr-1"
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditClick(template);
                }}
              >
                <EditIcon />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(template.id);
                }}
              >
                <DeleteIcon />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PredefinedQuery;
